var map = {
	"./blue_economy_details.svg": "1a90",
	"./business_in_transition_details.svg": "cd2f",
	"./green_use_of_land_details.svg": "066b",
	"./social_economy_details.svg": "00cd",
	"./sustainable_energy_details.svg": "b1b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33c4";